/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {number}
 */

export const PersonRelationType = {
  ORGANIZATION: 4,
  PARENT_LINKED: 2,
  SPOUSE: 3,
  SIBLING: 5,
  PARENT_UNLINKED: 6,
  EMPLOYER: 7,
  EMERGENCY_CONTACT: 10,
  PURCHASE_RECIPIENT: 11,
} as const;

export type PersonRelationType =
  (typeof PersonRelationType)[keyof typeof PersonRelationType];

export type PersonRelationTypeEnumType = typeof PersonRelationType;
export type PersonRelationTypeOptional = PersonRelationType;
export type PersonRelationTypeTrackedI = PersonRelationType;
export type PersonRelationTypeTracked = PersonRelationType;
export type PersonRelationTypeMetaI = EnumMetaType<
  PersonRelationTypeEnumType,
  PersonRelationType
>;
export const PersonRelationTypeMeta = typeMetaEnum<
  PersonRelationTypeEnumType,
  PersonRelationType
>("PersonRelationType", PersonRelationType);
export function transformDatesPersonRelationType(model: PersonRelationType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
